import React from 'react';

const PatientDeleteAppointmentModal = ({ 
    show, 
    isDeleting, 
    onConfirm, 
    onCancel 
}) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-semibold text-gray-900">Delete Appointment</h3>
                    <button 
                        onClick={onCancel}
                        className="text-gray-400 hover:text-gray-600"
                    >
                        ×
                    </button>
                </div>
                <div className="mb-6">
                    <p className="text-gray-700">Are you sure you want to delete this appointment?</p>
                </div>
                <div className="flex gap-3 justify-end">
                    <button 
                        onClick={onConfirm}
                        disabled={isDeleting}
                        className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50"
                    >
                        {isDeleting ? 'Deleting...' : 'Yes'}
                    </button>
                    <button 
                        onClick={onCancel}
                        className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PatientDeleteAppointmentModal;
